export const zoneLocations = [
  { id: 1, name: 'Elevator' },
  { id: 2, name: 'Restroom Men' },
  { id: 3, name: 'Restroom Women' },
  { id: 4, name: 'Conference Room' },
  { id: 5, name: 'Main Lobby' },
  { id: 6, name: 'Fitness Center' },
];
